import { CONFIG } from 'config/config';

import { isMobile } from 'react-device-detect';
import styled from 'styled-components/macro';

export const MinInputsWraper = styled.div`
	width: 100%;
	display: ${isMobile ? 'flex' : 'flex'};
	flex-direction: row;
	gap: 20px;
	align-items: center;
	justify-content: 'space-between';
`;

export const RadioButtonInt = styled.div`
	width: 16px;
	height: 16px;
	border-radius: 16px;
	background-color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.primary;
		} else {
			return CONFIG.colors.white;
		}
	}};
	color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.white;
		} else {
			return CONFIG.colors.primary;
		}
	}};
`;

export const RadioButton = styled.div`
	position: relative;
	cursor: pointer;

	border: 2px solid ${CONFIG.colors.primary};
	border-radius: 24px;
	width: 24px;
	height: 24px;
	outline: none;

	display: flex;
	align-items: center;
	justify-content: center;

	:hover {
		${RadioButtonInt} {
			background-color: ${CONFIG.colors.primary};
			transition: 0.3s all;
		}
	}
`;

export const StepCircle = styled.div`
	height: ${isMobile ? '22px' : '24px'};
	width: ${isMobile ? '22px' : '24px'};
	background-color: ${CONFIG.colors.primary};
	border-radius: 50%;
	margin-right: 15px;
	font-size: ${isMobile ? '16px' : '17px'};
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 700;
`;
